export const calendar = {
  strict: true, // true => strict update state from component

  state: {
    register: 0,
    update: null,
    registeredEvents: [],
    updatedEvents: [],
    deletedEvents: [],
    dialog: { detail: false, edit: false },
  },

  getters: {},

  mutations: {
    CAL_DIALOG_DETAIL: (state, payload) => {
      state.dialog.detail = payload;
    },
    CAL_DIALOG_EDIT: (state, payload) => {
      state.dialog.detail = payload;
    },
    CAL_REGISTER: (state, payload) => {
      state.register = payload;
    },
    CAL_APPEND_REGISTERED: (state, payload) => {
      state.registeredEvents.push(payload);
    },
    CAL_UPDATE: (state, payload) => {
      state.update = payload;
    },
    CAL_APPEND_UPDATED: (state, payload) => {
      state.updatedEvents.push(payload);
    },
    CAL_DELETED: (state, payload) => {
      state.deletedEvents.push(payload);
    },
    CAL_CLEAR_EDITS: (state, payload) => {
      state.registeredEvents = [];
      state.updatedEvents = [];
      state.deletedEvents = [];
    },
  },
};
